module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "imgCode-bg"
  }), _vm._v(" "), _c('div', {
    staticClass: "imgCodeBox"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("图片验证码")]), _vm._v(" "), _c('div', {
    staticClass: "item-imgCode"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.imgCode),
      expression: "imgCode"
    }],
    staticClass: "imgCode-input",
    attrs: {
      "type": "text",
      "maxlength": "4",
      "placeholder": "请输入图片验证码"
    },
    domProps: {
      "value": (_vm.imgCode)
    },
    on: {
      "blur": _vm.checkInput,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.imgCode = $event.target.value
      }
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "imgCode",
    attrs: {
      "src": _vm.imgCodeUrl
    },
    on: {
      "click": _vm.freshValidateCode
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isError),
      expression: "isError"
    }],
    staticClass: "error-p"
  }, [_c('i', {
    staticClass: "icon-warning"
  }), _vm._v(" "), _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorInfo))])])]), _vm._v(" "), _c('div', {
    staticClass: "btns"
  }, [_c('span', {
    staticClass: "btn",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('span', {
    staticClass: "btn main-btn",
    on: {
      "click": _vm.checkImgCode
    }
  }, [_vm._v("确定")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-484bb5be","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/module/basic/components/basic/mobile/imgCode.vue
// module id = 348
// module chunks = 0